import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Filters from "../../components/Filters";
import NoMatching from "../../components/NoMatching";
import { showInResults } from "../../utils/helper";
import Profiles from "./Profiles";
import Search from "./Search";
import { selectAllUsers } from "./usersSlice";

const UsersList = () => {
  //   const [specialty, setSpecialty] = useState([]);
  const users = useSelector(selectAllUsers);
  const [filteredUsers, setFiltersUsers] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [location, setLocation] = useState([]);
  const [levelOfEducation, setLevelOfEducation] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [selectedChoices, setSelectedChoices] = useState({
    Sector: [],
    Location: [],
    Level_of_Education: [],
  });

  const handleSearch = (e) => {
    var checkboxes = document.getElementsByTagName("input");
    for (var checkbox of checkboxes) {
      checkbox.checked = false;
    }
    const value = e.target.value;
    setSearch(value);
    let newUsers = users.filter((user) =>
      user.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFiltersUsers(newUsers);
  };

  let newPage = page;
  const onScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.scrollHeight - 200
    ) {
      setPage(newPage++);
    }
  };

  useEffect(() => {
    let newUsers = users.filter(showInResults, { selectedChoices });
    setPage(1);
    setFiltersUsers(newUsers);
    // eslint-disable-next-line
  }, [selectedChoices]);

  useEffect(() => {
    // const uniqueSpecialty = [...new Set(users.map((item) => item.Specialty))];
    setFiltersUsers(users);
    const uniqueSector = [...new Set(users.map((item) => item.Sector))];
    const uniqueLocation = [...new Set(users.map((item) => item.Location))];
    const uniqueLevelOfEducation = [
      ...new Set(users.map((item) => item.Level_of_Education)),
    ];
    setSectors(uniqueSector);
    setLocation(uniqueLocation);
    setLevelOfEducation(uniqueLevelOfEducation);
    // setSpecialty(uniqueSpecialty);
  }, [users]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, false);
    return () => {
      window.removeEventListener("scroll", onScroll, true);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <div className="grid grid-cols-1 md:grid-cols-6">
        <Filters
          sectors={sectors}
          levelOfEducation={levelOfEducation}
          location={location}
          setSelectedChoices={setSelectedChoices}
          selectedChoices={selectedChoices}
        />
        <div className="col-span-4" onScroll={() => onScroll()}>
          <Search search={search} handleSearch={handleSearch} />
          {filteredUsers.length ? (
            <Profiles page={page} filteredUsers={filteredUsers} />
          ) : (
            <NoMatching />
          )}
        </div>
      </div>
    </div>
  );
};

export default UsersList;
